import { createContext } from 'react'
import { Button, Divider, Grid, Paper } from 'presentation/components/atoms'
import { PageHeader } from 'presentation/components/molecules'
import { PaymentDetail } from './components/paymentDetail/paymentDetail'
import { StatusInformation } from './components/statusInformation/statusInformation'
import { OrderItems } from './components/orderItems/orderItems'
import { OrderTrackingSkeleton } from './components/orderTrackingSkeleton/orderTrackingSkeleton'
import { useMediaQuery } from '@mui/material'
import { Content } from 'presentation/components'
import { useNavigate } from 'react-router-dom'
import { useOrderTracking } from './hooks/useOrderTracking'
import { useFilter, usePagination } from '@/main/hooks'
import { atomWithHash } from 'jotai-location'
import { IOrder } from './hooks/utils/interfaces/iOrder'
import { IOrderItems } from './hooks/utils/interfaces/iOrderItems'

interface ItemsContent {
  orderItems: IOrderItems
  isLoading: boolean
  filter: any
  goToPage: (page: number) => void
  setPageSize: (pageSize: number) => void
  updateFilter: (filterValues: object) => void
}
export interface IOrderTrackingContext extends IOrder {
  isRecharge: boolean
  items: ItemsContent
}

const filterAtom = atomWithHash<object>('orderItemsFilter', {})
const paginationAtom = atomWithHash<object>('orderItemsPagination', null)
export const OrderTrackingContext = createContext<IOrderTrackingContext>({} as IOrderTrackingContext)

export const OrderTracking = () => {
  const shouldBreak = useMediaQuery('@media (max-width:1150px)')

  const navigate = useNavigate()
  const { filter, updateFilter } = useFilter({ filterAtom })
  const { pagination, goToPage, setPageSize } = usePagination({
    paginationAtom,
    initialValue: {
      page: 1,
      pageSize: 200,
    },
    outputMap: {
      page: 'pagina',
      pageSize: 'qtdLinhas',
    },
  })

  const { order, isLoading, isItemsLoading } = useOrderTracking({ filter, pagination })

  const isRecharge = true

  const handleReturn = () => navigate('/recargas')

  return (
    <Content>
      <OrderTrackingContext.Provider
        value={{
          ...order,
          isRecharge,
          items: {
            filter,
            goToPage,
            setPageSize,
            updateFilter: (data: any) => updateFilter({ pesquisa: data.filterValue }),
            isLoading: isItemsLoading,
            orderItems: order?.orderItems,
          },
        }}
      >
        <Paper sx={{ padding: '32px', overflow: 'auto' }}>
          <PageHeader pageTitle='Acompanhamento de Pedido' padding='0' noDivider />
          <Divider sx={{ margin: '32px 0' }} />
          {isLoading || !order ? (
            <OrderTrackingSkeleton />
          ) : (
            <Grid container spacing='32px' justifyContent='space-between'>
              <Grid item xs={12} sm={12} md={shouldBreak ? 12 : 8} lg={7}>
                <StatusInformation />
                <OrderItems />
              </Grid>
              <Grid item xs={12} sm={12} md={shouldBreak ? 12 : 4} lg={5}>
                <PaymentDetail />
              </Grid>
              <Grid item xs={12} sm='auto' sx={{ marginLeft: 'auto' }}>
                <Button variant='outlined' onClick={handleReturn} fullWidth>
                  Voltar
                </Button>
              </Grid>
            </Grid>
          )}
        </Paper>
      </OrderTrackingContext.Provider>
    </Content>
  )
}
